<h3 class="first-heading" *ngIf="!isAdmin && !isPersonalDetail">Enter</h3>
<h5 class="second-heading" *ngIf="!isAdmin && !isPersonalDetail" [class.detail]="isPersonalDetail">Personal Details</h5>

<section class="campaign" *ngIf="isPersonalDetail">
    <div class="campaign__heading">
        <div>
            <h1>Business Personal Details</h1>
        </div>
        <div></div>
    </div>
</section>

<div [class.register-page]="isPersonalDetail">
    <div [class.register-page__main]="isPersonalDetail">
        <div [class.register-page__main__content]="isPersonalDetail">

            <form [formGroup]="personalForm" (ngSubmit)="onSubmit()">

                <div class="form">
                    <div class="form__main">

                        <!-- First Name Field -->
                        <div class="form__main__fields">
                            <app-form-field-input label="First Name" [required]="true"
                                [control]="personalForm.controls.firstName" formControlName="firstName"
                                placeholder="First Name">
                            </app-form-field-input>
                        </div>

                        <!-- Middle Name Field -->
                        <div class="form__main__fields">
                            <app-form-field-input label="Middle Name" [control]="personalForm.controls.middleName"
                                formControlName="middleName" placeholder="Middle Name">
                            </app-form-field-input>
                        </div>

                        <!-- Last Name Field -->
                        <div class="form__main__fields">
                            <app-form-field-input label="Last Name" [required]="true"
                                [control]="personalForm.controls.lastName" formControlName="lastName"
                                placeholder="Last Name">
                            </app-form-field-input>
                        </div>

                        <!-- User Name  -->
                        <div class="form__main__fields" *ngIf="isAdmin">
                            <app-form-field-input label="User Name" [required]="true"
                                [control]="personalForm.controls.userName" formControlName="userName"
                                placeholder="User Name *">
                            </app-form-field-input>
                        </div>

                        <!-- CNIC Field -->
                        <div class="form__main__fields">
                            <app-form-field-input-mask label="CNIC" [required]="true"
                                [control]="personalForm.controls.cnic" formControlName="cnic" mask="00000-0000000-0"
                                placeholder="CNIC">
                            </app-form-field-input-mask>
                        </div>

                        <!-- Date Of Birth Field -->
                        <div class="form__main__fields">
                            <app-form-field-date label="Date of Birth" [required]="true"
                                [control]="personalForm.controls.dob" formControlName="dob" placeholder="Date of Birth"
                                [max]="maxDate" [not18]="not18">
                            </app-form-field-date>
                        </div>

                        <!-- Gender Field -->
                        <div class="form__main__fields">
                            <app-form-field-select label="Gender" [required]="true"
                                [control]="personalForm.controls.genderId" formControlName="genderId"
                                [items]="metaData?.gender">
                            </app-form-field-select>
                        </div>

                        <!-- Mobile Number Field -->
                        <div class="form__main__fields">

                            <div class="operator">
                                <div class="operator__select">
                                    <app-form-field-select label="Network" [required]="true"
                                        [control]="personalForm.controls.networkId" formControlName="networkId"
                                        [items]="metaData?.mobileNetwork">
                                    </app-form-field-select>
                                </div>
                                <div class="operator__number">
                                    <app-form-field-input-mask label="Mobile Number" [required]="true"
                                        formControlName="phoneNumber" prefix="03" mask="00-0000000"
                                        placeholder="03xx-xxxxxxx" [control]="personalForm.controls.phoneNumber">
                                    </app-form-field-input-mask>
                                    <!-- <app-form-field-input label="Mobile Number" [required]="true" *ngIf="userProfile"
                                            formControlName="phoneNumber"
                                            [control]="personalForm.controls.phoneNumber">
                                        </app-form-field-input> -->
                                </div>
                            </div>

                        </div>

                        <!-- Email Field  -->
                        <div class="form__main__fields">
                            <app-form-field-input label="Email" [required]="false"
                                [control]="personalForm.controls.email" [patternError]="regexErrors.email"
                                formControlName="email" placeholder="Email">
                            </app-form-field-input>
                        </div>

                        <!-- Province Field  -->
                        <div class="form__main__fields">
                            <app-form-field-select label="Province" [required]="true"
                                [control]="personalForm.controls.provinceId" formControlName="provinceId"
                                [items]="metaData?.province" (changed)="selectProvince($event)">
                            </app-form-field-select>
                        </div>

                        <!-- City Field  -->
                        <div class="form__main__fields">
                            <app-form-field-select label="City" [required]="true"
                                [control]="personalForm.controls.cityId" formControlName="cityId"
                                [items]="provinceCities">
                            </app-form-field-select>
                        </div>

                        <!-- Area Field  -->
                        <div class="form__main__fields">
                            <app-form-field-input label="Area" [required]="true" [control]="personalForm.controls.area"
                                formControlName="area" placeholder="Area">
                            </app-form-field-input>
                        </div>

                        <!-- Sub Area Field  -->
                        <div class="form__main__fields">
                            <app-form-field-input label="Sub Area" [required]="true"
                                [control]="personalForm.controls.subArea" formControlName="subArea"
                                placeholder="Sub Area">
                            </app-form-field-input>
                        </div>

                        <!-- Referred By Field -->
                        <div class="form__main__fields" *ngIf="!isAdmin">
                            <app-form-field-select label="Referred By" [required]="false"
                                [control]="personalForm.controls.referredById" formControlName="referredById"
                                [items]="metaData?.referredByType">
                            </app-form-field-select>
                        </div>

                        <!-- Department Field -->
                        <div class="form__main__fields" *ngIf="isAdmin && departmentRolesMeta">
                            <app-form-field-select label="Department" [required]="true"
                                [items]="departmentRolesMeta?.deparment" [control]="personalForm.controls.departmentId"
                                formControlName="departmentId">
                            </app-form-field-select>
                        </div>

                        <!-- Select lstRoles Field -->
                        <div class="form__main__fields mt" *ngIf="isAdmin">
                            <mat-label>Roles</mat-label>
                            <ng-multiselect-dropdown [placeholder]="'Select'" [settings]="dropdownSettings"
                                [data]="dropdownList" formControlName="lstRoles" (onSelect)="onItemSelect($event)"
                                (onSelectAll)="onSelectAll($event)" (onDeSelect)="onItemDeSelect($event)"
                                (onDeSelectAll)="onItemDeSelectAll($event)">
                            </ng-multiselect-dropdown>
                            <div class="error" [class.error_active]="lstRoles">
                                <span *ngIf="lstRoles && isSubmitted">Role is <strong>required</strong>.</span>
                            </div>
                        </div>

                        <!-- New Password Field  -->
                        <div class="form__main__fields" *ngIf="!isCreate">
                            <app-form-field-password label="New Password" [required]="true" [iconLabel]="false"
                                [control]="personalForm.controls.password" [patternError]="regexErrors.password"
                                formControlName="password" placeholder="New Password">
                            </app-form-field-password>
                        </div>

                        <!-- Confirm Password Field  -->
                        <div class="form__main__fields" *ngIf="!isCreate">
                            <app-form-field-password label="Confirm Password" [required]="true" [iconLabel]="false"
                                [control]="personalForm.controls.confirmPassword" formControlName="confirmPassword"
                                placeholder="Confirm Password">
                            </app-form-field-password>
                            <div class="error" [class.error_active]="personalForm.hasError('repeat')">
                                Entered passwords don't match
                            </div>
                        </div>

                        <!-- i agree Checkbox  -->
                        <div class="agree" *ngIf="!isAdmin && !isEditMode">
                            <label>
                                <input type="checkbox" (change)="changeAgreeCheck($event)" formControlName="agree">
                                <span>I agree to the</span>
                                <a class="app-a" href="https://zekli.com/tnc_v1.html" target="_blank"
                                    title="Terms & Conditions">
                                    Terms and Conditions
                                </a>
                            </label>

                            <div class="error" [class.error_active]="f.agree.errors && isSubmitted">
                                <small>Please check <strong>Terms & conditions</strong>.</small>
                            </div>
                        </div>

                        <form [formGroup]="approvalForm" *ngIf="profile && !isPartyUser" class="mt_30_neg">
                            <div class=" form__main__registration form__main__fields">

                                <mat-radio-group class="cmp-radio-group" formControlName="registrationTypeId"
                                    [required]="true" [disabled]="false">
                                    <mat-radio-button class="cmp-radio-button" [value]="130"
                                        (change)="registrationTypeChange($event.value)">
                                        Self Registration
                                    </mat-radio-button>
                                    <mat-radio-button class="cmp-radio-button" [value]="132"
                                        (change)="registrationTypeChange($event.value)">
                                        Business Development User

                                    </mat-radio-button>
                                    <mat-radio-button class="cmp-radio-button" [value]="131"
                                        (change)="registrationTypeChange($event.value)">
                                        Others
                                    </mat-radio-button>
                                </mat-radio-group>


                            </div>
                            <div class="form__main__fields" class="ml_10"> 
                                <app-form-field-select *ngIf="isBDURegistration" label="Business Development User"
                                    [control]="personalForm.controls.taggedUserId" formControlName="taggedUserId"
                                    [items]="metaData?.bdUsers">
                                </app-form-field-select>

                                <app-form-field-input *ngIf="isOtherRegistration" label="Registration Detail"
                                    [control]="personalForm.controls.otherDetails" placeholder="Details"
                                    formControlName="otherDetails">
                                </app-form-field-input>

                            </div>
                        </form>
                    </div>
                </div>

                <!-- Buttons  -->
                <div class="app-center" *ngIf="!isAdmin && !isEditMode">
                    <button class="app-button" mat-button matStepperPrevious><i class="fa fa-angle-left"></i>
                        Back</button>
                    <app-button type="submit">Register</app-button>
                </div>

                <div style="display: table; margin: auto;" *ngIf="isAdmin && isProfileEditable">
                    <button *ngIf="helperService.lstUserRights[enumService.SCREENS.ManageUser].canCreate" type="button"
                        (click)="submitCreateUserForm()" class="app-button mr-1">{{ !isCreate ? 'Create' : 'Update'
                        }}</button>
                </div>

                <div style="display: flex; justify-content: center;" *ngIf="isPersonalDetail">
                    <button class="app-button mr-1" type="button" mat-button matStepperPrevious><i
                            class="fa fa-angle-left"></i> Back</button>
                    <button class="app-button mr-1" type="button"
                        *ngIf="profileDetail?.isEditable && helperService.lstUserRights[enumService.SCREENS.UserProfile].canUpdate"
                        (click)="submit()">Update</button>
                    <button class="app-button  mr-1" type="button" (click)="approveUser()"
                        *ngIf="profile?.user.approvalStatusId == 4 && helperService.lstUserRights[enumService?.SCREENS?.ManageUser].canUpdate">Approve</button>
                    <button class="app-button mr-1" type="button" (click)="rejectUser()"
                        *ngIf="profile?.user.approvalStatusId == 4 && helperService.lstUserRights[enumService?.SCREENS?.ManageUser].canUpdate">Reject</button>
                    <button class="app-button" type="button" mat-button matStepperNext>Next <i
                            class="fa fa-angle-right"></i></button>
                </div>

            </form>

        </div>
    </div>
</div>


<!-- 
<code>
    {{ personalForm.value | json }}
</code> -->